import React, { Component } from 'react';
import * as _ from 'lodash-es';
import Utils, { FilterAccessibility } from '../../sr-utils';
import FilterParentListItem from './FilterParentListItem';
import CalciteButton from '../../../shared/CalciteButton';
import CalciteLink from  '../../../shared/CalciteLink';

class Filters extends Component {
	constructor(props) {
		super(props);
		this.props = props;
		Utils.getfilterData(props);
		this.activeFilter = null;
		this.filterSearchItems = [];
		this.isFilterHidden = this.props.isFilterCatOpen == 'true' ? false : true;
		this.handleFilterSelection = this.handleFilterSelection.bind(this);
		this.handleClearFilters = this.handleClearFilters.bind(this);
		this.filterFunctionUpdated = this.filterFunctionUpdated.bind(this);
		this.closeFilterModal = this.closeFilterModal.bind(this);
		this.handleScrimClick = this.handleScrimClick.bind(this);
		this.handleEscKey = this.handleEscKey.bind(this);
		this.openFilterGroup = this.openFilterGroup.bind(this);
		this.closeFilterGroup = this.closeFilterGroup.bind(this);
		this.handleFocusTrap = this.handleFocusTrap.bind(this);
		this.handleMediaChange = this.handleMediaChange.bind(this);
		this.desktopQuery = null;
		this.filterclass = '';
		this.filtersDataCopy = this.props.filtersData;
		this.state = {
			filtersData: this.filtersDataCopy,
			activeGroupIndex: null,
			isDesktop: typeof window !== 'undefined' && window.matchMedia('(min-width: 1281px)').matches,
		};
	}

	componentDidMount() {
		let filterTree = document.querySelector('#filtertree');
		if (filterTree != null) {
			new FilterAccessibility(filterTree);
		}
		document.addEventListener('keydown', this.handleEscKey);

		// Listen for viewport changes to toggle dialog vs region semantics
		this.desktopQuery = window.matchMedia('(min-width: 1281px)');
		this.desktopQuery.addEventListener('change', this.handleMediaChange);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleEscKey);
		if (this.desktopQuery) {
			this.desktopQuery.removeEventListener('change', this.handleMediaChange);
		}
	}

	handleEscKey(e) {
		const filterModal = document.querySelector('.search-results-app-filter');
		if (e.key === 'Escape' && filterModal?.getAttribute('data-expanded') === 'true') {
			this.closeFilterModal();
		}
	}

	closeFilterModal() {
		const filterModal = document.querySelector('.search-results-app-filter');
		const scrim = document.querySelector('.filter-modal-overlay');

		// Restore focus to the element that triggered the modal
		const previouslyFocused = filterModal?._previouslyFocusedElement;

		if (filterModal) {
			filterModal.setAttribute('data-expanded', 'false');
			document.body.style.overflow = '';
		}
		if (scrim) {
			scrim.setAttribute('aria-hidden', 'true');
		}
		this.setState({ activeGroupIndex: null });

		if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
			requestAnimationFrame(() => {
				previouslyFocused.focus();
			});
		}
	}

	handleScrimClick() {
		this.closeFilterModal();
	}

	openFilterGroup(index) {
		this.setState({ activeGroupIndex: index }, () => {
			// Move focus to the back button in the newly visible panel
			requestAnimationFrame(() => {
				const activePanel = document.querySelector('.filter-group-panel--active .filter-group-back-btn');
				if (activePanel) {
					activePanel.focus();
				}
			});
		});
	}

	closeFilterGroup() {
		const previousIndex = this.state.activeGroupIndex;
		this.setState({ activeGroupIndex: null }, () => {
			// Restore focus to the nav button that opened this group
			requestAnimationFrame(() => {
				const navButtons = document.querySelectorAll('.filter-group-nav-btn');
				if (navButtons[previousIndex]) {
					navButtons[previousIndex].focus();
				}
			});
		});
	}

	/**
	 * Traps focus inside the filter dialog when it is expanded.
	 * On Tab past the last focusable element, wraps to the first; on Shift+Tab
	 * before the first, wraps to the last.
	 */
	handleFocusTrap(e) {
		if (e.key !== 'Tab') {
			return;
		}

		const dialog = e.currentTarget;
		const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), calcite-button:not([disabled]), calcite-link:not([disabled]), calcite-checkbox';
		const focusableElements = [...dialog.querySelectorAll(focusableSelectors)].filter(
			(el) => el.offsetParent !== null && !el.closest('[aria-hidden="true"]')
		);

		if (focusableElements.length === 0) {
			return;
		}

		const firstFocusable = focusableElements[0];
		const lastFocusable = focusableElements[focusableElements.length - 1];

		if (e.shiftKey) {
			// Shift+Tab: wrap from first → last
			if (document.activeElement === firstFocusable) {
				e.preventDefault();
				lastFocusable.focus();
			}
		} else {
			// Tab: wrap from last → first
			if (document.activeElement === lastFocusable) {
				e.preventDefault();
				firstFocusable.focus();
			}
		}
	}

	handleMediaChange(e) {
		this.setState({ isDesktop: e.matches });
		// If resized to desktop while modal was open, clean up modal state
		if (e.matches) {
			const filterModal = document.querySelector('.search-results-app-filter');
			const scrim = document.querySelector('.filter-modal-overlay');
			if (filterModal) {
				filterModal.setAttribute('data-expanded', 'false');
			}
			if (scrim) {
				scrim.setAttribute('aria-hidden', 'true');
			}
			document.body.style.overflow = '';
		}
	}

	handleFilterSelection(e) {
		let target = e.target;
        if (target.tagName === 'CALCITE-CHECKBOX') {
          target = target.parentElement;
        }
		let sField = target.getAttribute('data-field');
		let sValue = target.getAttribute('data-value');
		this.handleFiltersUpdates(sField, sValue);
	}

	handleFiltersUpdates(sField, sValue) {
		let params = new URLSearchParams(window.location.search.slice(1));

		// Search if matching filter and value exists in url
		let filterValues = params.getAll(sField);
		let i = 0;
		let found = false;
		while (i < filterValues.length && !found) {
			if (filterValues[i] === sValue) {
				found = true;
			}
			i++;
		}

		// If matching filter and value exists, delete
		if (found) {
			// This is to format values into urlsearchparams format to deal with special characters
			// and delete the field and value if it exists
			let encodedValue = encodeURIComponent(sValue.replace(/\+/g, ' '));
			let filterTupleToDelete = new URLSearchParams(sField + '=' + encodedValue);
			params = new URLSearchParams(params.toString().replace(filterTupleToDelete.toString(), ''));
		}
		// Else add to url
		else {
			params.append(sField, sValue);
		}
		// In both cases, delete page, p
		params.delete('p');

		window.history.replaceState({}, '', window.location.pathname + '?' + params);
		this.props.handleSubmit();
	}

	handleClearFilters() {
      if(this.props.activeFilters.length > 0){
		let params = new URLSearchParams(window.location.search.slice(1));

		// Gets filter=value pairs
		let filterTuples = params.toString().split('&');

		// Deletes filters
		for (let i = 0; i < filterTuples.length; i++) {
			let filter = filterTuples[i].split('=');
			// Deletes filters include page, p, but not query, q
            // Ignoring gh_src is a special case for careers search and filter
			if (filter[0] !== 'q' && filter[0] !== 'wcmmode' && filter[0] !== 'gh_src') {
				params.delete(filter[0]);
			}
		}

		window.history.replaceState({}, '', window.location.pathname + '?' + params);
		this.props.handleSubmit();
      }
	}

  filterFunctionUpdated(e) {
    let parentFilters = JSON.parse(JSON.stringify(this.filtersDataCopy));
    let target = e.target;
    let filterInput = target.value || '';
    if (filterInput !== '') {
      let indx = target.getAttribute('id').split('-')[1];
      let subFilterCopy = parentFilters[indx].subFilters.slice();
      let newsubFilterArray = [];
      subFilterCopy.forEach((item) => {
        let filterlabel = item.label;
        if (filterlabel.toLowerCase().indexOf(filterInput.toLowerCase()) > -1) {
          newsubFilterArray.push(item);
        }
      });
      parentFilters[indx].subFilters = newsubFilterArray;
    }
    this.setState({ filtersData: parentFilters });
  }

	render() {
		if (!this.state.filtersData) {
			return null;
		}
		let tempFiltersData = this.state.filtersData;

		let clearFiltersText = this.props.labels.clearFilterLabel;
		let filterheadingLabel = this.props.labels.filterLabel;
		let isChecked = this.props.isFilterCatOpen === 'true';
		let activeFiltersMap = {};

		if (this.props.activeFilters.length) {
			let activeFilters = Utils.getCurrFiltersArr(this.props.activeFilters);
			activeFilters.forEach((_filter) => {
				if (activeFiltersMap[_filter.cat] === undefined) {
					activeFiltersMap[_filter.cat] = {};
				}
				activeFiltersMap[_filter.cat][_filter.value] = true;
			});
		}

		let TopLevelFilters = tempFiltersData.map((filter, indx) => {
			if (filter.subFilters) {
				return (
                  <FilterParentListItem
                    key={indx}
                    indx={indx}
                    filter={filter}
                    isChecked={isChecked}
                    isFilterHidden={this.isFilterHidden}
                    filterFunctionUpdated={this.filterFunctionUpdated}
                    handleFilterSelection={this.handleFilterSelection}
                    activeFiltersMap={activeFiltersMap}
                  />
				);
			}

			// For parent filter links.
			if (filter.name.indexOf('=') > -1) {
				let filterLabel = filter.label.trim();
				let [filterField, filterName] = filter.name.split('=');
				filterField = filterField.trim();
				filterName = filterName.trim();
				let isSelected = null; // reset
				if (activeFiltersMap[filterField] && activeFiltersMap[filterField][filterName]) {
					isSelected = 'selected';
				}

				return (
					<li
                      key={indx}>
                      <calcite-label
                        layout="inline"
                        class="filter-link filter-link--parent"
                        data-attribute={isSelected}
                        onClick={this.handleFilterSelection}
                        data-field={filterField}
                        data-value={filterName}
                        data-label={filterLabel}
                        tabIndex="0">
                        {isSelected === 'selected' ?
                          <calcite-checkbox checked scale="m" status="idle" calcite-hydrated=""></calcite-checkbox> :
                          <calcite-checkbox scale="m" status="idle" calcite-hydrated=""></calcite-checkbox>
                        }
                        {filterLabel}
                        </calcite-label>
					</li>
				);
			}
		});

			// Build filter group nav items for the two-panel mobile/tablet layout
		let FilterGroupNavItems = tempFiltersData.map((filter, indx) => {
			if (filter.subFilters) {
				let filterLabel = filter.label.trim();
				let filterName = filter.name.trim();
				let hasActive = activeFiltersMap[filterName] && Object.keys(activeFiltersMap[filterName]).length > 0;
				let activeCount = hasActive ? Object.keys(activeFiltersMap[filterName]).length : 0;

				return (
					<li key={indx} className="filter-group-nav-item">
						<button
							type="button"
							className={`filter-group-nav-btn ${hasActive ? 'has-active' : ''}`}
							onClick={() => this.openFilterGroup(indx)}
							aria-expanded={this.state.activeGroupIndex === indx}
						>
							<span className="filter-group-nav-label">
								{filterLabel}
								{activeCount > 0 && <span className="filter-group-nav-count">{activeCount}</span>}
							</span>
							<calcite-icon icon="chevron-right" scale="s" aria-hidden="true"></calcite-icon>
						</button>
					</li>
				);
			}

			// For parent filter links in the nav panel
			if (filter.name.indexOf('=') > -1) {
				let filterLabel = filter.label.trim();
				let [filterField, filterName] = filter.name.split('=');
				filterField = filterField.trim();
				filterName = filterName.trim();
				let isSelected = null;
				if (activeFiltersMap[filterField] && activeFiltersMap[filterField][filterName]) {
					isSelected = 'selected';
				}
				return (
					<li key={indx} className="filter-group-nav-item filter-group-nav-item--link">
						<calcite-label
							layout="inline"
							class="filter-link filter-link--parent"
							data-attribute={isSelected}
							onClick={this.handleFilterSelection}
							data-field={filterField}
							data-value={filterName}
							data-label={filterLabel}
							tabIndex="0">
							{isSelected === 'selected' ?
								<calcite-checkbox checked scale="m" status="idle" calcite-hydrated=""></calcite-checkbox> :
								<calcite-checkbox scale="m" status="idle" calcite-hydrated=""></calcite-checkbox>
							}
							{filterLabel}
						</calcite-label>
					</li>
				);
			}
		});

		// Build filter group detail panels
		let FilterGroupPanels = tempFiltersData.map((filter, indx) => {
			if (filter.subFilters) {
				return (
					<div
						key={indx}
						className={`filter-group-panel ${this.state.activeGroupIndex === indx ? 'filter-group-panel--active' : ''}`}
						aria-hidden={this.state.activeGroupIndex !== indx}
					>
						<div className="filter-group-panel-header">
							<button
								type="button"
								className="filter-group-back-btn"
								onClick={this.closeFilterGroup}
								aria-label="Back to filter groups"
							>
								<calcite-icon icon="chevron-left" scale="m" aria-hidden="true"></calcite-icon>
							</button>
							<span className="filter-group-panel-title">{filter.label.trim()}</span>
							<button
								type="button"
								className="filter-group-panel-close-btn"
								onClick={this.closeFilterModal}
								aria-label="Close filters"
							>
								<calcite-icon icon="x" scale="m" aria-hidden="true"></calcite-icon>
							</button>
						</div>
						<div className="filter-group-panel-content">
							<FilterParentListItem
								indx={indx}
								filter={filter}
								isChecked={isChecked}
								isFilterHidden={false}
								filterFunctionUpdated={this.filterFunctionUpdated}
								handleFilterSelection={this.handleFilterSelection}
								activeFiltersMap={activeFiltersMap}
								showAllItems={true}
							/>
						</div>
					</div>
				);
			}
			return null;
		});

		// check if filters are active, var is used to set clear filter active state
		let hasActiveFilters = _.isEmpty(activeFiltersMap) ? '' : 'selected';

		// On desktop the filter is a persistent sidebar — use region semantics.
		// Below 1281px it becomes a modal dialog — apply dialog semantics.
		const isModalMode = !this.state.isDesktop;

		return (
			<>
				<div className="filter-modal-overlay" aria-hidden="true" onClick={this.handleScrimClick}></div>
				<div
					className="column-5 search-results-app-filter"
					id="filter"
					data-expanded="false"
					role={isModalMode ? 'dialog' : 'region'}
					aria-modal={isModalMode ? 'true' : undefined}
					aria-label={filterheadingLabel}
					onKeyDown={isModalMode ? this.handleFocusTrap : undefined}
				>
					<div className={`filter-heading ${this.state.activeGroupIndex !== null ? 'filter-heading--hidden' : ''}`}>
						<div className="filter-heading-text">
							<p>{filterheadingLabel}</p>
						</div>
						<button
							type="button"
							className="filter-modal-close-btn"
							aria-label="Close filters"
							onClick={this.closeFilterModal}
						>
							<calcite-icon icon="x" scale="m" aria-hidden="true"></calcite-icon>
						</button>
						<div className="filter-heading-clear">
							<CalciteButton
								onClick={this.handleClearFilters}
								disabled={hasActiveFilters === 'selected' ? null : true }
								appearance="transparent"
								alignment="center"
								kind="neutral"
								scale="m"
								type="button"
								width="auto">
								{clearFiltersText}
							</CalciteButton>
						</div>
					</div>

					{/* Desktop filter tree (>= 1280px) */}
					<div className="filter-content">
						<div className="filter-content-navigation">
							<ul id="filtertree">
								{TopLevelFilters}
							</ul>
						</div>
					</div>

					{/* Mobile/Tablet two-panel navigation (< 1280px) */}
					<div className="filter-modal-panels">
						<div className={`filter-groups-list ${this.state.activeGroupIndex !== null ? 'filter-groups-list--hidden' : ''}`}>
							<ul className="filter-group-nav">
								{FilterGroupNavItems}
							</ul>
						</div>
						<div className={`filter-group-detail ${this.state.activeGroupIndex !== null ? 'filter-group-detail--active' : ''}`}>
							{FilterGroupPanels}
						</div>
					</div>

					<div className="filter-modal-footer">
						<CalciteLink
							onClick={this.handleClearFilters}
							disabled={hasActiveFilters === 'selected' ? undefined : true}
							href="#">
							{clearFiltersText}
						</CalciteLink>
						<CalciteButton
							onClick={this.closeFilterModal}
							appearance="solid"
							alignment="center"
							kind="brand"
							scale="m"
							type="button"
							width="auto">
							See results
						</CalciteButton>
					</div>
				</div>
			</>
		);
	}
}

export default Filters;
